import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setSendReceiptFormAction } from "../../redux/rootReducer";
import { SEND_RECEIPT_FORM_INITIAL } from "../../redux/initialStateConstant";
import { SendReceiptThunk } from "../../redux/thunks/SendReceiptThunk";
import { MarkPrepaymentThunk } from "../../redux/thunks/MarkPrepaymentThunk";

const ReceiptForm = () => {
    const dispatch = useDispatch();
    const send_receipt_form = useSelector(state => state.send_receipt_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(setSendReceiptFormAction(SEND_RECEIPT_FORM_INITIAL)) }/>
                        <div className="form__title">Отправка чека</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Ссылка на чек</div>
                        <input className="input" type="text"
                            value={ send_receipt_form.receipt_link }
                            onInput={ event => dispatch(setSendReceiptFormAction({
                                ...send_receipt_form,
                                receipt_link: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(SendReceiptThunk({
                                    invoice_id: send_receipt_form.invoice_id,
                                    period: send_receipt_form.period,
                                    counterparty_id: send_receipt_form.counterparty_id,
                                    receipt: send_receipt_form.receipt_link
                                }));
                            } }
                        >Отправить</div>
                    </div>
                    <div className="form__field">
                        <div className="button button--blue"
                             onClick={ () => {
                                 dispatch(MarkPrepaymentThunk({
                                     counterparty_id: send_receipt_form.counterparty_id,
                                     period: send_receipt_form.period,
                                     invoice_id: send_receipt_form.invoice_id
                                 }));
                             } }
                        >Чек уже выслан</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReceiptForm;